import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_v9th4ehh4b: FaireBrandEntity = {
  token: "b_v9th4ehh4b",
  type: "brand",
  name: "Two and Crew - Faith Based Jewelry & Gifts",
  avatarUrl:
    "https://cdn.faire.com/fastly/df90f682873a25d0d7853a5a7c669269d9db5a4d4ae295fee2eb2c6d9e6a22d0.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/f5c428a9ad65a46e4ef230d5c97574356e51e10b112448cfe0693d441c20c163.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/df90f682873a25d0d7853a5a7c669269d9db5a4d4ae295fee2eb2c6d9e6a22d0.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/f5c428a9ad65a46e4ef230d5c97574356e51e10b112448cfe0693d441c20c163.jpeg",
  location: "Layton, UT, USA",
  minimumOrderDollars: 151,
  rating: 4.9,
  reviewCount: 107,
  isTopShop: true,
  isInsider: true,
  description:
    "At Two and Crew, we are more than a wholesale jewelry & accessories company—we are a faith-driven brand dedicated to creating meaningful, giftable pieces that inspire, encourage, & empower women. Every bracelet, necklace, & accessory is thoughtfully designed with uplifting messages of faith, gratitude, & hope, giving shop owners products that connect deeply with customers.\n\nThe name Two and Crew was inspired by our family: Husband & wife team & the growing “crew”. That heart for family, faith, and community is woven into everything we create. Each accessory is more than just jewelry—it’s a story, a reminder, & a gift that women love to wear & share.\n\nWe know what shop owners are looking for: wholesale best sellers, high-margin products, and unique gifts that stand out on shelves. That’s why our collections re designed to be both stylish and meaningful. These pieces are proven to resonate with customers in gift shops, Christian bookstores, and boutiques nationwide.\n\nBut our mission goes beyond product. We believe in true partnership with retailers—equipping you with collections that sell quickly, delight customers, and create repeat business. Our goal is to help you stock your store with accessories that matter, gifts that spark conversation, and jewelry that encourages hearts.\n\nJoin us in spreading positivity, embracing faith, and making a difference—one accessory, one shop, and one customer at a time.\n",
  meta: {
    source: "api",
    importedAt: "2026-04-19T21:45:03.397Z",
    importedBy: "entity-db-cli",
  },
};
